<template>
    <div class="warpper">
      <div class="order-data" >
        <div class="d-block" v-for="(item, i) in order_data_list" :key="i" :style="item.backGroundColor">
          <img :src="item.img" alt="" class="icon">
          <div class="i-block">
            <div class="name">{{item.name}}</div>
            <div class="num">{{item.num}}</div>
          </div>
        </div>
      </div>
      <div class="order-warn">
        <div class="title">订单提醒</div>
        <div style="display: flex;">
          <div v-for="(item, i) in order_warn_list" :key="i" class="w-block">
            <div class="word"><div class="num">{{item.num}}</div>
            <div class="name">{{item.name}}</div></div>
            <div class="line"></div>
          </div>
        </div>
      </div>
      <div class="home-chart">
        <div class="chart1">
          <div class="title">成交金额(元）</div>
          <div style="margin-left: 29px;">
            <span class="money">1500</span>
            <img src="@/assets/shop/up.png" alt="">
            <div class="info">较昨日上升0.9%</div>
            <div class="time">更新时间:2020/06/04</div>
          </div>
          <div>
            <div class="chart" id="orgHYl"></div>
          </div>
        </div>
        <div class="chart2">
          <div class="title">成交量(笔）</div>
          <div style="margin-left: 29px;">
            <span class="money">42</span>
            <img src="@/assets/shop/down.png" alt="">
            <div class="info">较昨日下降0.9%</div>
            <div class="time">更新时间:2020/06/04</div>
          </div>
          <div class="chart" id="orgHYl_2"></div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "home",
    components: {
      // chartone: () =>
      // import(/* webpackChunkName: "components" */ "./components/chart_one.vue"),
    },
    data() {
      return {
        order_data_list: [
          {
            name: '今日订单总数',
            num: '102,400',
            img: require('@/assets/shop/order.png'),
            backGroundColor: 'background: -webkit-linear-gradient(top, #A680FF, #8D62F4);'
          },
          {
            name: '今日销售总额',
            num: '81,212.00',
            img: require('@/assets/shop/money.png'),
            color_bottom: '#69ADFF',
            backGroundColor: 'background: -webkit-linear-gradient(top, #69ADFF, #69ADFF);'
          },
          {
            name: '在售商品数量',
            num: '9,280',
            img: require('@/assets/shop/goodsnum.png'),
            backGroundColor: 'background: -webkit-linear-gradient(top, #F56E96, #EA5883);'
          },
          {
            name: '近七天销售总额',
            num: '13,600',
            img: require('@/assets/shop/allmoney.png'),
            backGroundColor: 'background: -webkit-linear-gradient(top, #44D8C5, #41B1DB); margin: 0'
          },
        ],
        order_warn_list: [{
           name: '待付款订单',
           num: '341'
        },{
          name: '待发货订单',
           num: '1254'
        },{
          name: '待收货订单',
           num: '7895'
        },{
          name: '退款中订单',
           num: '0'
        },{
          name: '今日成交量',
           num: '52001'
        },{
          name: '今日交易额（元）',
           num: '1258.32'
        }],
        iconUrl: '@/assets/shop/up.png',
        
            // 'img' : '@/assets/shop/up.png'
      }
    },
    mounted() {
      this.chartPartFun();
      this.chartPartFun_2();
    },
    methods: {
    // chart1
    chartPartFun() {
      var chart = echarts.init(document.getElementById("orgHYl"));
      var option = {
        top: 25,
        xAxis: {
          type: "category",
          data: ["01/01", "01/02", "01/03", "01/04", "01/05", "01/06", "01/07"],
          boundaryGap: false,
          axisTick: {		//x轴刻度线
            show:false
          },
          axisLine: {
            show: false
          },
          offset: 25
        },
        grid: {
          left: "35px",
          right: "16px",
          top: "25px",
          bottom: "25px",
          containLabel: true
        },
        tooltip: {
          //trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          trigger: 'axis',                            //触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn:"mousemove|click",                      //提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent:true,                           //是否显示提示框浮层
          alwaysShowContent:false,                     //是否永远显示提示框内容
          showDelay:0,                                  //浮层显示的延迟，单位为 ms
          hideDelay:100,                                //浮层隐藏的延迟，单位为 ms
          enterable:false,                             //鼠标是否可进入提示框浮层中
          confine:false,                               //是否将 tooltip 框限制在图表的区域内
          transitionDuration:0.4,                      //提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          position:['50%', '50%'],                    //提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          formatter:"{b0}: {c0}<br />{b1}: {c1}",     //提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          backgroundColor:"transparent",            //标题背景色
          borderColor:"#ccc",                        //边框颜色
          borderWidth:0,                              //边框线宽
          padding:5,                                  //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
        },

        yAxis: {
          type: "value",
          axisLine: { show: false },
          splitLine: { show: false },
          offset: 25
        },
        series: [
          {
            data: [0, 36, 32, 60, 40, 90, 60],
            type: "line",
            symbolSize: 8,
            symbol: 'none',   //去掉折线上的小圆点
            smooth: true,
            itemStyle: {
              normal: {
                color: "#4B80F6"
              }
            },
            areaStyle: {
              //渐变色
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#4B80F6" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            } //填充区域样式
          }
        ]
      };

      chart.setOption(option);
      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    // chart2
    chartPartFun_2() {
      var chart = echarts.init(document.getElementById("orgHYl_2"));
      var option = {
        top: 25,
        xAxis: {
          type: "category",
          data: ["01/01", "01/02", "01/03", "01/04", "01/05", "01/06", "01/07"],
          boundaryGap: false,
          axisTick: {		//x轴刻度线
            show:false
          },
          axisLine: {
            show: false
          },
          offset: 25
        },
        grid: {
          left: "35px",
          right: "16px",
          top: "25px",
          bottom: "25px",
          containLabel: true
        },
        tooltip: {
          //trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          trigger: 'axis',                            //触发类型,'item'数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。 'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
          triggerOn:"mousemove|click",                      //提示框触发的条件,'mousemove'鼠标移动时触发。'click'鼠标点击时触发。'mousemove|click'同时鼠标移动和点击时触发。'none'不在 'mousemove' 或 'click' 时触发
          showContent:true,                           //是否显示提示框浮层
          alwaysShowContent:false,                     //是否永远显示提示框内容
          showDelay:0,                                  //浮层显示的延迟，单位为 ms
          hideDelay:100,                                //浮层隐藏的延迟，单位为 ms
          enterable:false,                             //鼠标是否可进入提示框浮层中
          confine:false,                               //是否将 tooltip 框限制在图表的区域内
          transitionDuration:0.4,                      //提示框浮层的移动动画过渡时间，单位是 s,设置为 0 的时候会紧跟着鼠标移动
          position:['50%', '50%'],                    //提示框浮层的位置，默认不设置时位置会跟随鼠标的位置,[10, 10],回掉函数，inside鼠标所在图形的内部中心位置，top、left、bottom、right鼠标所在图形上侧，左侧，下侧，右侧，
          formatter:"{b0}: {c0}<br />{b1}: {c1}",     //提示框浮层内容格式器，支持字符串模板和回调函数两种形式,模板变量有 {a}, {b}，{c}，{d}，{e}，分别表示系列名，数据名，数据值等
          backgroundColor:"transparent",            //标题背景色
          borderColor:"#ccc",                        //边框颜色
          borderWidth:0,                              //边框线宽
          padding:5,                                  //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
        },

        yAxis: {
          type: "value",
          axisLine: { show: false },
          splitLine: { show: false },
          offset: 25
        },
        series: [
          {
            data: [0, 36, 32, 60, 40, 90, 60],
            type: "line",
            symbolSize: 8,
            symbol: 'none',   //去掉折线上的小圆点
            smooth: true,
            itemStyle: {
              normal: {
                color: "#E062AE"
              }
            },
            areaStyle: {
              //渐变色
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#E062AE" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#fff" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            } //填充区域样式
          }
        ]
      };

      chart.setOption(option);
      window.addEventListener("resize", () => {
        chart.resize();
      });
    }
    },

  }
</script>

<style lang="scss" scoped>
  .warpper  .home-chart {
    @include chart-class;
  }
  .warpper{
    width: 100%;
    height: 100%;
    min-width: 1236px;
  }
  .d-block{
    display: inline-block;
    width: 374px;
    height: 134px;
    margin-right: 32px;
    flex: 1;
    box-shadow: 0px 0px 7px 0px rgba(5, 29, 81, 0.4);
    border-radius: 8px;
  }
  .icon{
    width: 56px;
    height: 56px;
    margin: 39px 9px 0px 50px;
  }
  .order-data{
    display: flex;
  }
  .i-block{
    display: inline-block;
    position: relative;
    bottom: 8px;
  }
  .i-block .name {
    font-size: 12px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #F9F8FD;
  }
  .i-block .num{
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #F9F8FD;
  }
  .order-warn{
    padding-top: 27px;
    height: 196px;
    width: 100%;
    background-color: #fff;
    margin-top: 21px;
    box-shadow: 0px 0px 7px 0px rgba(5, 29, 81, 0.06);
    border-radius: 8px;
    
  }
  .w-block{
    flex: 1;
    text-align: center;
  }
  .title{
    
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color:blue;
    margin-left: 30px;
  }
  .line{
    width: 1px;
    height: 45px;
    background: #E5E5E5;
  }
  .w-block .num{
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #4B80F6;
  }
  .w-block .name{
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  .word{
    position: relative;
    top: 40px;
  }
  .line{
    float: right; 
    position: relative;
    bottom: 10px;
  }
  .home-chart{
    display: flex;
    margin-top: 20px;
    height: calc(100% - 390px); 
    min-height: 550px;
    /* background-color: #fff; */
    margin-bottom: 48px;
  }
  .chart1{
    flex: 0.5;
    background-color: #fff;
    height: 100%; 
  }
  .chart2{
    flex: 0.5;
    background-color: #fff;
    height: 100%; 
    margin-left: 34px;
  }
  .home-chart  .title{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #323232;
    margin: 25px 0 23px 31px;
  }
  .money{
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #3E3E3E;
    display: inline-block;
    margin-right: 7px;
  }
  .info{
    display: inline-block;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    position: relative;
    bottom: 5px;
    margin-left: 4px;
  }
  .time{
    display: inline-block;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    margin-left: 31px;
    position: relative;
    bottom: 5px;
  }
  .chart {
    /* //flex-direction: column; */
    height: 390px;
    margin-top: 10px;
    background-color: #4B80F6;
    padding: 30px;

    
  }
  /* .way {
     margin: 0 auto;
      @include s-c-w(14, $text-one, 400);
      height: 13px;
      line-height: 13px;
     
    } */
    /* .line {
        width: 20px;
        height: 2px;
        border-radius: 1px;
        background-color: $chart-one;
        margin-top: 6px;
        margin-right: 6px;
      } */
</style>
